/**
 * ハッシュカウントの取得
 */

import Utils from '../utils/main.es6';


export default class HashCount{
    
    constructor(){
        this.hashCount = 0;
        this.isClear = false;
        this.query = Utils.getQuery() || {};
    }


    async sendAPI(sceneId){
        
        try {
            const res = await BOCCHI_IMPRESSION_API?.register(sceneId);
            if(res.status) console.log('resigst: ', sceneId);
            else throw new Error(res.reason);
        }
        catch(e){
            console.log(e.message);
        }
    }


    async getAPI(callback=null){
        this.hashCount = await BOCCHI_IMPRESSION_API?.fetchCount();
        if(this.query.count) this.hashCount = parseInt(this.query.count);

        document.body.setAttribute('data-counter', this.hashCount);
        
        this._checkClear();
        if(callback) callback();
    }



    get(){
        return this.hashCount;
    }


    _checkClear(){
        
        // クリア済みかどうか。data-clearの値でHTMLの表示が切り替わる。
        if(this.hashCount >= 69000){
            document.body.setAttribute('data-clear', 1);
            this.isClear = true;
        }
        else{
            document.body.setAttribute('data-clear', 0);
            this.isClear = false;
        }

        // スタジオOKが出ていないため、一時的に達成演出をOFF
        //document.body.setAttribute('data-clear', 0);
        //this.isClear = false;
    }
}